import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { getConsent, setConsent } from "@/lib/analytics";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
  }, []);

  const accept = () => {
    setConsent({ analytics: true, date: new Date().toISOString() });
    setVisible(false);
  };
  const refuse = () => {
    setConsent({ analytics: false, date: new Date().toISOString() });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Gestion des cookies"
      className="fixed inset-x-0 bottom-0 z-[70] p-4 md:p-6"
    >
      <div className="max-w-4xl mx-auto bg-brand-black text-white rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.4)] p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4">
        <Cookie className="w-8 h-8 text-brand-gold shrink-0 hidden md:block" />
        <div className="flex-1">
          <p className="text-sm text-white/85 leading-relaxed">
            Nous utilisons des cookies de mesure d'audience pour améliorer votre expérience. Aucun cookie non essentiel n'est déposé sans votre accord.{" "}
            <Link to="/gestion-cookies" className="text-brand-gold underline">En savoir plus</Link>.
          </p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button
            data-testid="cookie-refuse-btn"
            onClick={refuse}
            className="flex-1 md:flex-none px-5 py-2.5 rounded-full border border-white/30 text-white font-bold text-sm hover:bg-white/10 transition-colors"
          >
            Refuser
          </button>
          <button
            data-testid="cookie-accept-btn"
            onClick={accept}
            className="flex-1 md:flex-none px-5 py-2.5 rounded-full bg-brand-gold text-brand-black font-bold text-sm hover:opacity-90 transition-opacity"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
};
